import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

interface IRedesignedOutOfStockTextProps {
  isOutOfStock?: boolean;
  showOutOfStock: boolean;
  dataTestId: string;
}

export const RedesignedOutOfStockText: React.FC<
  IRedesignedOutOfStockTextProps
> = ({ isOutOfStock, showOutOfStock, dataTestId }) => {
  if (isOutOfStock && showOutOfStock) {
    return (
      <Typography
        variant="paragraphSansRegular"
        color={Core.text.critical}
        data-test-id={dataTestId}
      >
        <StrictLocalMsg
          defaultMessage="Out of stock"
          description={{
            text: "This product is currently unavailable.",
          }}
        />
      </Typography>
    );
  } else {
    return null;
  }
};
